import axios from "axios";

export default class userManagement {
  constructor() {
    this.API_LINK = process.env.VUE_APP_API_LINK;
    // this.API_LINK = 'http://localhost:8014'
  }

  async getUsers() {
    try {
      const response = await axios({
        method: "get",
        url: `${this.API_LINK}/v1/admin-users`,
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async createUser(data) {
    try {
      const response = await axios({
        method: "post",
        url: `${this.API_LINK}/v1/admin-users`,
        "data": data
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async getUserDetails(data) {
    try {
      const response = await axios({
        method: "get",
        url: `${this.API_LINK}/v1/admin-users/${data}`,
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async updateUser(number,data) {
    try {
      const response = await axios({
        method: "put",
        url: `${this.API_LINK}/v1/admin-users/${number}`,
        "data": data
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }
  async sendEmail(email) {
    try {
      const response = await axios({
        method: "post",
        url: `${this.API_LINK}/v1/admin-users/recovery`,
        "data": {email}
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }


   async getUsersV3() {
    try {
      const response = await axios({
        method: "get",
        url: `${this.API_LINK}/v3.0/users/permissions`,
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async getListpermisions() {
    try {
      const response = await axios({
        method: "get",
        url: `${this.API_LINK}/v3.0/permissions/categories?status=ENABLED`,
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async getUserDetailsV3(data) {
    try {
      const response = await axios({
        method: "get",
        url: `${this.API_LINK}/v3.0/users/${data}/permissions`,
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async createEditUserV3(controlNumber,data) {
    try {
      const response = await axios({
        method: "post",
        url: `${this.API_LINK}/v3.0/users/${controlNumber}/permissions`,
        "data": data
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }
  
}
